export enum Rule {
	EQUAL = 'EQUAL',
	NOT_EQUAL = 'NOT_EQUAL',
}
